import {TRootState} from "types";
import {TMarketReportReducerState} from "store/market-report/types";

export const loadingMarketReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).loadingMarketReport;
export const creatingMarketReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).creatingMarketReport;
export const updatingMarketReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).updatingMarketReport;
export const deletingMarketReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).deletion_in_progress;
export const duplicatingMarketReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).duplicatingMarketReport;
export const displayMarketReportModalSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).displayMarketReportModal;
export const getMarketReportsSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).results;
export const getMarketReportsPaginationSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).pagination;
export const getMarketReportCreatedBySelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).createdBy;
export const getMarketReportFormSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).marketReportForm;
export const getMarketReportDetailsSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).marketReportDetails;
export const getMRSelectedCompaniesSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).selectedCompanies;
export const mrDiversityStatsLoadingSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversityStatsLoading;
export const mrDiversityStatsSelectedTypeSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversityStatsSelectedType;
export const mrDiversityStatsReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversityStatsReport;
export const mrDiversePathwaysLoadingSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversePathwaysLoading;
export const mrDiversePathwaysSelectedTypeSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversePathwaysSelectedType;
export const mrDiversePathwaysModeSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversePathwaysMode;
export const mrDiversePathwaysReportSelector = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).diversePathwaysReport;
export const mrDisabledFilterKeysOnCriteriaBreakDown = (state: TRootState) =>
	(state.marketReport as TMarketReportReducerState).disabledFilterKeysOnCriteriaBreakDown;
